import {ACTION_TYPE} from "utils/constants";
import produce from "immer";

const {
  ADD_OBJECT,
  OBJECT_ADDED,
  DELETE_OBJECT,
  COPY_OBJECT,
  // SET_OBJECT,
  REORDER_OBJECT,
  ADD_GUI,
  DELETE_GUI,
  CONCEAL_OBJECT,
  REVEAL_OBJECT,

  ADD_AD_BANNER,

  ADD_SCENE,
  DELETE_SCENE,
  SELECT_SCENE,
  // SCENE_LOADED,

  CHANGE_PROPERTY,
  CHANGE_PROPERTY_FROM_SCENE,
  SELECT_MODE,
  SELECT_OBJECT,
  UNSELECT_OBJECT,
  PREVIEW_CAMERA,

  CHANGE_SCRIPT,

  SAVE_FILE,
  LOAD_FILE,
  UPLOAD_FILE,
  SAVE_PROJECT,
  LOAD_GLB,
  LOAD_FROM_PID,
  EXPORT_GLB,
} = ACTION_TYPE;

// DO NOT DELETE
// const defaultObject = {
//   key: "world",
//   type: "model", // camera, light, audio, model, ...
//   title: "World",
//   visible: true,
//   parent: "",
//   children: [
//     // model,
//   ]
// };

// DO NOT DELETE
// const defaultScene = {
//   key: "world",
//   type: "scene",
//   title: "World",
//   visible: true,
//   parent: "",
//   children: [/*defaultObject*/],
//   sky: '',
//   ground: '',
//   selectedObjects: [],
// };

const initialState = {
  selectedSceneName: "default",
  selectedObjectKeys: [],
  selectedObjects: [],

  action: {
    command: "",
    category: "",
    name: "",
    object: undefined,
    target: "",
    timestamp: "",
    adInfo: "",
  },

  thumbnails: {},

  scenes: {
    // [defaultScene.name]: {
    //  ...defaultScene
    // }
  },
};

const asset = (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case ADD_OBJECT:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: payload.category,
          name: payload.name,
          object: payload.object,
          timestamp: Date.now(),
        };

        draft.thumbnails[payload.name] = payload.thumbnail;
      });

    case SELECT_OBJECT:
      return produce(state, draft => {
        // payload.target === "2D" case ?
        draft.selectedObjectKeys = [];
        draft.selectedObjectKeys.push(payload.uuid);

        draft.selectedObjects = [];
        let objs;
        if (payload.target === "2D") {
          objs = getSelectedObjects(draft.scenes["GUI"], draft.selectedObjectKeys);
        } else {
          objs = getSelectedObjects(draft.scenes[draft.selectedSceneName], draft.selectedObjectKeys);
        }
        if (objs !== undefined) draft.selectedObjects.push(...objs);
        // draft.scenes[draft.selectedSceneName].selectedObjects = [];
        // draft.scenes[draft.selectedSceneName].selectedObjects.push(payload);
        draft.action = {
          command: type,
          category: type,
          name: payload.uuid,
          target: payload.target,
          timestamp: Date.now(),
        };
      });

    case UNSELECT_OBJECT:
      return produce(state, draft => {
        draft.selectedObjectKeys = [];
        draft.selectedObjects = [];
        // draft.scenes[draft.selectedSceneName].selectedObjects = [];
      });

    case DELETE_OBJECT:
      return produce(state, draft => {
        draft.selectedObjectKeys = [];
        draft.selectedObjects = [];
        draft.action = {
          command: type,
          category: type,
          name: payload,
          timestamp: Date.now(),
        };
      });

    case COPY_OBJECT:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: type,
          name: "copy",
          timestamp: Date.now(),
        };
      });

    case ADD_SCENE:
      return produce(state, draft => {
        draft.selectedObjectKeys = [];
        draft.selectedObjects = [];
        draft.selectedSceneName = payload.name || "default";
        draft.scenes[draft.selectedSceneName] = payload;
      });

    // unnessesary to push object, because scene will add child on three.js
    case OBJECT_ADDED:
      return produce(state, draft => {
        draft.selectedObjectKeys = [];
        draft.selectedObjectKeys.push(payload.uuid);
        draft.selectedObjects = [];
        draft.selectedObjects.push(payload);
        // draft.scenes[draft.selectedSceneName].selectedObjects = [];
        // draft.scenes[draft.selectedSceneName].selectedObjects.push(payload);
      });

    case SAVE_FILE:
    case LOAD_FILE:
    case UPLOAD_FILE:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: "file",
          genre: payload.genre,
          name: payload.name,
          description: payload.description,
          thumbnail: payload.thumbnail,
          timestamp: Date.now(),
          isWorldExist: payload.isWorldExist,
          group: payload.group ? payload.group : undefined,
          class: payload.class ? payload.class : undefined,
          competitionType: payload.competitionType,
          phoneNumber: payload.phoneNumber,
          agreementDate: payload.agreementDate,
        };
      });

    case LOAD_GLB:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: "glb",
          name: "glb",
          timestamp: Date.now(),
        };
      });
    case ACTION_TYPE.LOAD_FROM_PID:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: "file",
          targetPID: payload,
        };
      });

    case EXPORT_GLB:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: "exportGlb",
          name: "exportGlb",
          timestamp: Date.now(),
        };
      });

    case SAVE_PROJECT:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: "project",
          name: payload,
          timestamp: Date.now(),
        };
      });

    case ADD_GUI:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: payload.category,
          name: payload.name,
          thumbnail: payload.thumbnail,
          timestamp: Date.now(),
        };

        draft.thumbnails[payload.name] = payload.thumbnail;
      });

    case DELETE_GUI:
      return action.bool;

    case ADD_AD_BANNER:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: payload.category,
          name: payload.name,
          thumbnail: payload.thumbnail,
          adInfo: payload.adInfo,
          timestamp: Date.now(),
        };
      });

    case DELETE_SCENE:
      return action.bool;

    case SELECT_SCENE:
      return action.bool;

    case CHANGE_PROPERTY:
      return produce(state, draft => {
        draft.action = {
          command: type,
          category: payload.category,
          name: payload.name,
          value: payload.value,
          timestamp: Date.now(),
        };
      });

    case CHANGE_PROPERTY_FROM_SCENE:
      return produce(state, draft => {
        draft.selectedObjectKeys = [];
        draft.selectedObjects = [];
        if (payload) {
          draft.selectedObjectKeys.push(payload.uuid);
          draft.selectedObjects.push(payload);
        }
      });

    case SELECT_MODE:
      return action.bool;

    case PREVIEW_CAMERA:
      return action.bool;

    case CHANGE_SCRIPT:
      // return produce(state, draft => {
      //   const { userData } = draft.scenes[draft.selectedSceneName];
      //   const { code, json } = payload;
      //   userData.script = code;
      //   userData.oobcJSON = json;
      // })

      return produce(state, draft => {
        draft.action = {
          command: type,
          category: type,
          name: type,
          value: payload,
          timestamp: Date.now(),
        };
      });

    case REORDER_OBJECT:
      return produce(state, draft => {
        draft.action = {
          command: type,
          value: payload.info,
          target: payload.target,
          timestamp: Date.now(),
        };
      });

    case CONCEAL_OBJECT:
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: payload.uuid,
          target: payload.target,
          timestamp: Date.now(),
        };
      });

    case REVEAL_OBJECT:
      return produce(state, draft => {
        draft.action = {
          command: type,
          name: payload.uuid,
          target: payload.target,
          timestamp: Date.now(),
        };
      });

    default:
      return state;
  }
};

export default asset;

function getSelectedObjects(scene, ids = []) {
  if (ids === undefined || ids.length === 0) return;
  const selectedObjects = [];
  scene.traverse(obj => {
    if (ids.includes(obj.uuid)) selectedObjects.push(obj);
  });
  return selectedObjects;
}
